export default __webpack_public_path__ + "static/tidb-cloud-banner-3c737359c9a2623bbaea4d28e6176e87.svg";